module.exports = __webpack_public_path__ + "img/cb28a5c.svg";